//import shifts from '../assets/data/shifts'
import Vue from 'vue'
import axios from 'axios'
import * as _ from 'lodash';
import moment from 'moment';

export const STATUS_NEW = 10;
export const STATUS_PUBLICATED = 20;
export const STATUS_DRAFT = 30;

export const STATUS_ASSIGNED = 10; // default
export const STATUS_FREE = 20;
export const STATUS_STALE = 30; // rejected by driver

export const INTERVAL_DAY = 10;
export const INTERVAL_WEEK = 20;
export const INTERVAL_TWO_WEEK = 30;
export const INTERVAL_MONTH = 40;

// -- fill time list
let timeList = [];
let time_iterator = moment.utc("00:00", "HH:mm");
const part_time_interval = 15;
for (let i = 0; i < (24 * 60) / part_time_interval; i++) {
  timeList.push({
    name: time_iterator.format("HH:mm"),
    value: time_iterator.format("HH:mm"),
  });

  time_iterator.add(part_time_interval, "m");
}

export const DATE_RANGE_HELPERS = {
    dayToRange: function(date, interval_id) {
        let start_of_period = moment(date, "YYYY-MM-DD"); // .startOf('isoWeek');
        let end_of_period = moment(date, "YYYY-MM-DD");

        switch(interval_id) {
            case INTERVAL_DAY:
                break;
            case INTERVAL_WEEK:
                end_of_period.add(1, 'w').subtract(1, 'd');
                break;
            case INTERVAL_TWO_WEEK:
                end_of_period.add(2, 'w').subtract(1, 'd');
                break;
            case INTERVAL_MONTH:
                end_of_period.add(1, 'months').subtract(1, 'd');
                break;
        }

        return [
            start_of_period.format("YYYY-MM-DD"),
            end_of_period.format("YYYY-MM-DD")
        ];
    },
    dateRangeText: function (date_range_selected) {
        if (!date_range_selected) {
            return '~';
        }

        let start_of_week = moment(date_range_selected[0], "YYYY-MM-DD").format('DD MMM');
        let end_of_period = moment(date_range_selected[1], "YYYY-MM-DD").format('DD MMM');

        return [start_of_week, end_of_period].join(' ~ ');
    },
    getShiftHours: function(shift_item) {
        //-- calc `shift_hours`
        let finish_time = moment(shift_item.finish_time, "HH:mm");
        let start_time = moment(shift_item.start_time, "HH:mm");
        if (!finish_time.isValid() || !start_time.isValid()) {
            return 0;
        }
  
        if (finish_time.format("HH:mm") < start_time.format("HH:mm")) {
          finish_time.add(1, 'd');
        }
  
        return ( (finish_time - start_time) / (60 * 1000) ) / 60;
    }
}

export default {
    state: {
        shifts: [],
        period_date_from: void 0,
        period_date_to: void 0,
        timeList: timeList,
    },
    mutations: {
        fetchShifts(state, { payload, period_date_from, period_date_to}) {
            state.shifts = payload
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        createNewShift(state, payload) {
            // fix to prevent double insert(from http and Socket.io), check is shift already inserted (by this application instance)
            let shift = _.find(state.shifts, p => p.id == payload.id);
            if (shift) {
                return; // exit
                //? or pass to update
            }

            // check is shift inserted in current date range
            if (state.period_date_from <= payload.period_date
                && state.period_date_to >= payload.period_date
            ) {
                state.shifts.push(payload);
            }
        },
        removeShift(state, payload) {
            for (let i = 0; i < state.shifts.length; i++) {
                if (payload.id == state.shifts[i].id) {
                    state.shifts.splice(i, 1); // remove item
                    break; // founded exit
                }
            }
        },
        setShifts(state, payload) {
            state.shifts = payload;
        },
        editShift(state, payload) {
            const index = state.shifts.findIndex(item => item.id === payload.id);
            if (index == -1) { // if shift not founded (draft)
                // check is shift inserted in current date range
                if (state.period_date_from <= payload.period_date
                    && state.period_date_to >= payload.period_date
                ) {
                    state.shifts.push(payload);
                }
            } else {
                Vue.set(state.shifts, index, payload);
            }
        },
        editShiftTimeSheet(state, payload) {
            const index = state.shifts.findIndex(item => item.id === payload.shift_id);
            if (index == -1) {
                return;
            }

            let shift = state.shifts[index];
            shift.timesheet = payload;

            Vue.set(state.shifts, index, shift);
        },
        removeShiftTimeSheet(state, payload) {
            const index = state.shifts.findIndex(item => item.id === payload.shift_id);
            if (index == -1) {
                return;
            }

            let shift = state.shifts[index];
            shift.timesheet = null;

            Vue.set(state.shifts, index, shift);
        },
        updateShifts(state, shifts_payload) {
            for (let i = 0; i < shifts_payload.length; i++) {
                const index = state.shifts.findIndex(item => +item.id === +shifts_payload[i].id);
                Vue.set(state.shifts, index, shifts_payload[i]);
            }
        },
        removeShifts(state, shifts_payload) {
            for (let j = 0; j < shifts_payload.length; j++) {
                for (let i = 0; i < state.shifts.length; i++) {
                    if (shifts_payload[j].id == state.shifts[i].id) {
                        state.shifts.splice(i, 1); // remove item
                        break; // founded exit
                    }
                }
            }
        },
        moderateFreeShifts(state, shifts_payload) {
            for (let i = 0; i < shifts_payload.length; i++) {
                const index = state.shifts.findIndex(item => +item.id === +shifts_payload[i].id);
                Vue.set(state.shifts, index, shifts_payload[i]);
            }
        },
        copyShifts(state, shifts_payload) {
            const index = state.shifts.findIndex(item => item.id === shifts_payload.id);
            Vue.set(state.shifts, index, shifts_payload);
        },
        cancelShift(state, shifts_payload) {
            const index = state.shifts.findIndex(item => item.id === shifts_payload.id);
            Vue.set(state.shifts, index, shifts_payload);
        }
    },

    actions: {
        async fetchShifts({ commit, dispatch }, {period_date_from, period_date_to, with_timesheet, with_driver, filter_draft}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let with_timesheet_param = '';
                if (with_timesheet == '1') {
                    with_timesheet_param = '&with_timesheet=1';
                }

                let with_driver_param = '';
                if (with_driver == '1') {
                    with_driver_param = '&with_driver=1';
                }

                let filter_draft_param = '';
                if (filter_draft == '1') {
                    filter_draft_param = '&filter_draft=1';
                }

                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/shift?period_date_from=${period_date_from}&period_date_to=${period_date_to}${with_timesheet_param}${with_driver_param}${filter_draft_param}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('fetchShifts', {payload: data, period_date_from, period_date_to});
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async createNewShift({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('createNewShift', data)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async removeShift({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/shift/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('removeShift', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }

                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async editShift({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/shift/${payload.id}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('editShift', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async publishShifts({commit, dispatch}, {shifts, options}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let shift_ids = _.map(shifts, p => p.id);
                let post_data = {
                    shift_ids: shift_ids,
                    push_drivers: options.push_drivers == 10 ? 10 : 20,
                };

                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift/publish`, post_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('updateShifts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async unpublishShifts({commit, dispatch}, {shifts, options}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let shift_ids = _.map(shifts, p => p.id);
                let post_data = {
                    shift_ids: shift_ids,
                    push_drivers: options.push_drivers == 10 ? 10 : 20,
                };

                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift/unpublish`, post_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('updateShifts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async removeShifts({commit, dispatch}, {shifts, options}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let shift_ids = _.map(shifts, p => p.id);
                let post_data = {
                    shift_ids: shift_ids,
                    push_drivers: options.push_drivers == 10 ? 10 : 20,
                };

                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift/remove`, post_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('removeShifts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async copyShifts({commit, dispatch}, {shifts, to_date}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let shift_ids = _.map(shifts, p => p.id);
                let post_data = {
                    shift_ids: shift_ids,
                    to_date: to_date,
                };

                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift/copyshifts`, post_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('copyShifts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        // restaurant private methods
        async createNewFreeShift({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift/createFree`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('createNewShift', data)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async editFreeShift({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/shift/updateFree/${payload.id}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('editShift', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async removeFreeShift({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/shift/removeFree/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('removeShift', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async copyShiftsFree({commit, dispatch}, {shifts, to_date}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let shift_ids = _.map(shifts, p => p.id);
                let post_data = {
                    shift_ids: shift_ids,
                    to_date: to_date,
                };

                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift/copyShiftsFree`, post_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('copyShifts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async moderateFreeShifts({commit, dispatch}, shifts) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let shift_ids = _.map(shifts, p => p.id);
                let post_data = {
                    shift_ids: shift_ids
                };

                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/shift/moderateFree`, post_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('moderateFreeShifts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async cancelShift({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true)
            let user = JSON.parse(localStorage.getItem('user'));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/reporting/create`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('cancelShift', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        }
    },

    getters: {
        shifts(state) {
            return state.shifts
        },
        shifts_period_date_from(state) {
            return state.period_date_from
        },
        shifts_period_date_to(state) {
            return state.period_date_to
        },
        timeList(state) {
            return state.timeList
        },
    }
}